import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { fetchAnalyticsDashboard } from "../services/api";
import AnalyticsTabs from "../components/analytics/AnalyticsTabs";
import OverviewTab from "../components/analytics/tabs/OverviewTab";
import AudienceTab from "../components/analytics/tabs/AudienceTab";
import UserJourneyTab from "../components/analytics/tabs/UserJourneyTab";
import MarketingTab from "../components/analytics/tabs/MarketingTab";
const tabMap = { overview: OverviewTab, marketing: MarketingTab, audience: AudienceTab, journeys: UserJourneyTab };
const AnalyticsDashboard = () => {
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const initialTab = searchParams.get("tab") || "overview";
  const [activeTab, setActiveTab] = useState(initialTab);

  useEffect(() => {
    if (activeTab !== "overview") {
      setLoading(false);
      return;
    }
    setLoading(true);
    fetchAnalyticsDashboard()
      .then((r) => {
        if (r.status === 1) {
          setDashboard(r.data);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));

  }, [activeTab]);

  useEffect(() => {
    const tab = searchParams.get("tab");
    if (tab && tab !== activeTab) {
      setActiveTab(tab);
    }
  }, [searchParams]);

 if (activeTab === "overview" && loading)return (
    <div className="flex flex-col items-center justify-center h-96 gap-3">
      <div className="w-8 h-8 border-2 border-indigo-600 border-t-transparent rounded-full animate-spin" />
      <p className="text-sm text-gray-500">Loading analytics...</p>
    </div>
  );

  const ActiveTab = tabMap[activeTab];

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Analytics</h1>
          <p className="text-sm text-gray-500 mt-0.5">Visitor activity and conversion insights</p>
        </div>
      </div>

      <AnalyticsTabs
        activeTab={activeTab}
        onChange={(tab) => {
          setActiveTab(tab);
          navigate(`?tab=${tab}`, {
            replace: true,
          });
        }}
      />
      <div className="min-h-0">
        {activeTab === "overview" ? <ActiveTab dashboard={dashboard} /> : <ActiveTab />}
      </div>
    </div>
  );
};

export default AnalyticsDashboard;